<template>
  <div>
    <div
      class="text-center d-flex flex-column justify-space-around"
      style="color: white; height: 100%"
    >
      <div>
        <div class="mb-3 mt-8">
        <h4 class="font-weight-light text-h6 text-sm-h6 text-uppercase">Curso de</h4>

        <h3 class="font-weight-bold text-h5 text-sm-h4 text-uppercase mb-4">
          Formação de Condutores de Veículos
        </h3>

        <span class="font-weight-bold secondary--text text-h6 text-sm-h6 text-uppercase py-2 px-4 white" style="border-radius: 4px;">
          MÓDULO 1 - LEGISLAÇÃO DE TRÂNSITO
        </span>
      </div>

      <div class="youtube-container">
        <youtube
          video-id="GMHv1M0hAxw"
          class="mt-8 elevation-10"
          style="border: solid 3px white"
          fitParent
        />
      </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  methods: {

  }
};
</script>

<style>
.youtube-container {
  margin: 0 auto;
}

@media (max-width: 600px) {
  .background-container {
    height: calc(100vh - 56px);
  }

  .youtube-container {
    width: 330px !important;
  }
}

@media (max-width: 1600px) {
  .youtube-container {
    width: 600px;
  }
}

@media (min-width: 1600px) {
  .youtube-container {
    width: 820px;
  }
}
</style>
